// @owners { team: patients }

import { SCROLLED_TO_BOTTOM } from '../../coupons/helpers/wrapHtmlContent';
import { WEB_VIEW_MOBILE_MAX_HEIGHT, WEB_VIEW_WEB_MAX_HEIGHT } from './termsWebViewConstants';

type HandleTermsWebViewMessageArgs =
  | {
      data: string;
      expectedOrigin: string;
      isWeb: true;
      onScrolledToBottom?: () => void;
      origin: string;
    }
  | {
      data: string;
      isWeb: false;
      onContentHeight?: (height: number) => void;
      onScrolledToBottom?: () => void;
    };

const parseContentHeight = (data: string): number | null => {
  try {
    const parsed = JSON.parse(data) as { type?: string; height?: number };
    if (parsed?.type === 'content_height' && typeof parsed.height === 'number') {
      return parsed.height;
    }
  } catch {
    // ignore non-JSON messages
  }

  return null;
};

const handleContentHeightMessage = ({
  height,
  maxHeight,
  onContentHeight,
  onScrolledToBottom,
}: {
  height: number;
  maxHeight: number;
  onContentHeight?: (height: number) => void;
  onScrolledToBottom?: () => void;
}) => {
  onContentHeight?.(height);
  if (height <= maxHeight) {
    onScrolledToBottom?.();
  }
};

export const handleTermsWebViewMessage = (args: HandleTermsWebViewMessageArgs) => {
  if (args.isWeb) {
    if (args.origin !== args.expectedOrigin) {
      return;
    }

    if (args.data === SCROLLED_TO_BOTTOM) {
      args.onScrolledToBottom?.();
      return;
    }

    const height = parseContentHeight(args.data);
    if (height !== null) {
      handleContentHeightMessage({
        height,
        maxHeight: WEB_VIEW_WEB_MAX_HEIGHT,
        onScrolledToBottom: args.onScrolledToBottom,
      });
    }

    return;
  }

  if (args.data === SCROLLED_TO_BOTTOM) {
    args.onScrolledToBottom?.();
    return;
  }

  const height = parseContentHeight(args.data);
  if (height !== null) {
    handleContentHeightMessage({
      height,
      maxHeight: WEB_VIEW_MOBILE_MAX_HEIGHT,
      onContentHeight: args.onContentHeight,
      onScrolledToBottom: args.onScrolledToBottom,
    });
  }
};
